// JavaScript Document

function initVideoModal() {


    const documentBody = document.querySelector('body');


    function playVideo(video) {

    
        var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
            && video.readyState > video.HAVE_CURRENT_DATA;
        if (!isPlaying) {
            setTimeout(function(){
                video.play();
            },100);
        }
    }

    function pauseVideo(video) {
        var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
            && video.readyState > video.HAVE_CURRENT_DATA;
        if (isPlaying) {
            video.pause();
            video.currentTime = 0;
            video
        }
    }



    function loadModal(videoUrl, videoPreviewImage) {


        
        loading.show(documentBody, 'pos', 'fixed');

        console.log(videoUrl, videoPreviewImage);


   
        var request = new XMLHttpRequest();
      
        request.open('POST', ajaxurl, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // If successful
                openModal(this.responseText);
            } else {
                // If fail
                openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
                //console.log(this.response);
            } 
        }; 
        request.onerror = function() {
            openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
        };
        request.send('action=load_video_modal&videoUrl='+videoUrl+'&videoPreviewImage='+videoPreviewImage);   
     
    }



    function openModal(html) {
        loading.hide();
        const modalHTML = `
            <div class="modal fade modal-video" id="videoModal" aria-hidden="true" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-video ">
            <div class="modal-content ">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="modal-inner">
                        ${html}
                    </div>
            </div>
            </div>
            </div>`;  

        appendHtml(document.body, modalHTML);


        const videoModal = document.getElementById('videoModal');

        const video = videoModal.querySelector('video');

        let bsVideoModal = new bootstrap.Modal('#videoModal', {
            keyboard: false
        });

        bsVideoModal.show();

        videoModal.addEventListener('shown.bs.modal', event => {
            playVideo(video);
        });

        videoModal.addEventListener('hidden.bs.modal', event => {
            pauseVideo(video);
        });
    }
    return {
        loadModal: loadModal,
    };
}
